import React from 'react'
import "../CSS/Template/badreq.css"
export default function BadRequestPage() {
  return (
    <>
    <div className="mainContainer">
      <div className="notFound">
        <h1>404 BAD REQUEST</h1>
        <p>Sorry Dear This Page Could't Be Found On The Server</p>
        <p>Click On The Logo Below To Go For Home Page</p>
        <a href="https://codearindam.com"><img src="https://img.icons8.com/ios/50/000000/home--v2.png"/></a>
      </div>
    </div>
    </>
  )
}

